import "./App.css";
import Components from "./Components";

function App() {
  return (
    <>
      <Components />
    </>
  );
}

export default App;
